import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutPseFormContainerComponent } from '@features/checkout-form-pse/components/checkout-pse-form-container/checkout-pse-form-container.component';

@Component({
  selector: 'angular-monorepo-checkout-form-movii',
  standalone: true,
  imports: [CommonModule,CheckoutPseFormContainerComponent],
  templateUrl: './checkout-form-movii.component.html',
  styleUrl: './checkout-form-movii.component.scss',
})
export class CheckoutFormMoviiComponent {}
